import { OrgChartData, OrgChartPerson } from '../types/scorecard';

export const initialOrgChartData: OrgChartPerson[] = [
 {
  "id": "ceo",
  "name": "CEO",
  "title": "BZ",
  "isHired": true,
  "level": 0,
  "position": {
   "x": 500,
   "y": 0
  },
  "lastUpdated": new Date("2026-02-22T14:25:09.088Z")
 },
 {
  "id": "cso",
  "name": "CSO",
  "title": "AS",
  "isHired": true,
  "parentId": "ceo",
  "level": 1,
  "position": {
   "x": 0,
   "y": 150
  },
  "lastUpdated": new Date("2026-02-22T14:25:13.351Z")
 },
 {
  "id": "cmo",
  "name": "CMO",
  "title": "FSN",
  "isHired": true,
  "parentId": "ceo",
  "level": 1,
  "position": {
   "x": 250,
   "y": 150
  },
  "lastUpdated": new Date("2026-02-22T14:25:17.360Z")
 },
 {
  "id": "cto",
  "name": "CTO",
  "title": "LP",
  "isHired": true,
  "parentId": "ceo",
  "level": 1,
  "position": {
   "x": 500,
   "y": 149.01731150426866
  },
  "lastUpdated": new Date("2026-02-22T14:25:22.180Z")
 },
 {
  "id": "regulatory-lead",
  "name": "Regulatory lead",
  "title": "SB",
  "isHired": false,
  "parentId": "ceo",
  "level": 1,
  "position": {
   "x": 750,
   "y": 150
  },
  "lastUpdated": new Date("2026-02-22T14:25:34.456Z")
 },
 {
  "id": "commercial-strategy",
  "name": "Commercial/Strategy Lead",
  "title": "Commercial & Strategy Lead",
  "isHired": false,
  "parentId": "ceo",
  "level": 1,
  "position": {
   "x": 1000,
   "y": 150
  },
  "lastUpdated": new Date("2026-02-22T14:22:17.438Z")
 },
 {
  "id": "software-dev",
  "name": "QARA + 62304",
  "title": "",
  "isHired": false,
  "parentId": "regulatory-lead",
  "level": 2,
  
  "position": {
   "x": 657.5365754126613,
   "y": 355.1557236322296
  },
  "lastUpdated": new Date("2026-02-28T14:21:59.005Z")
 },
 {
  "id": "lead-ai-engineer-1",
  "name": "Lead AI Engineer",
  "title": "Lead AI Engineer",
  "isHired": false,
  "parentId": "cto",
  "level": 2,
  "position": {
   "x": 366.5434887654018,
   "y": 350.06359211565933
  },
  "lastUpdated": new Date("2026-02-28T14:21:31.179Z")
 },
 {
  "id": "head-of-sales",
  "name": "Head of Sales",
  "title": "Head of Sales",
  "isHired": false,
  "parentId": "commercial-strategy",
  "level": 2,
  "position": {
   "x": 898.7263157894737,
   "y": 350
  },
  "lastUpdated": new Date("2026-02-22T14:24:59.396Z")
 },
 {
  "id": "account-manager",
  "name": "Account Manager",
  "title": "Account Manager",
  "isHired": false,
  "parentId": "commercial-strategy",
  "level": 2,
  "position": {
   "x": 1100,
   "y": 350
  },
  "lastUpdated": new Date("2026-02-22T14:22:17.438Z")
 }
];

export const defaultOrgChartData: OrgChartData = {
 people: initialOrgChartData,
 lastModified: new Date()
};